import { render, staticRenderFns } from "./invoice-details.vue?vue&type=template&id=de1c0d40&scoped=true&"
import script from "./invoice-details.ts?vue&type=script&lang=ts&"
export * from "./invoice-details.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-details.scss?vue&type=style&index=0&id=de1c0d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1c0d40",
  null
  
)

export default component.exports